import './ScoreSummary.scss';
import { getScoreClassName } from '../../../common/utils';
import ThumbsUpIcon from '../../../images/thumbsup-icon.png';
import WarningIcon from '../../../images/warning-icon.png';
import DangerIcon from '../../../images/danger-icon.png';

const scoreClassIconDict = {
  green: ThumbsUpIcon,
  yellow: WarningIcon,
  red: DangerIcon,
};

const scoreClassMessage = {
  green: "You're doing good! Read on for further tips.",
  yellow: 'Moderate. No worries, read on for more tips!',
  red: 'Can be improved. No fret, read on to learn!',
};

export const ScoreSummary = ({ score }) => {
  const scoreClass = getScoreClassName(score);
  return (
    <div className="score-summary">
      <div className={`score-summary-title`}>
        Your score: <span className={scoreClass}>{score}/10</span>
      </div>
      <div className={`score-summary-description ${scoreClass}`}>
        <img src={scoreClassIconDict[scoreClass]} alt="score-class-icon" />
        {scoreClassMessage[scoreClass]}
      </div>
    </div>
  );
};
